(ns quuppa.ui.layout
  (:require [reagent.core :as r]
            [quuppa.ui.button :as button]
            [quuppa.ui.util :as util]
            ["react-bootstrap/Collapse$default" :as Collapse]
            ["react-bootstrap/Fade$default" :as Fade]
            ["@restart/ui/Modal$default" :as Modal]))

(defn section
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)]
    (into [:section.section.d-flex.flex-row props]
          children)))

(defn view-content
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[{:keys [sidebar-open scroll-container padded? container class]
          :or {container true
               scroll-container true
               padded?          true}} children]
        (util/parse-args args) ]
    [:div.flex-column.flex-grow-1
     (r/merge-props {:class [(if sidebar-open
                               "d-none d-sm-flex"
                               "d-flex")
                             (when scroll-container
                               "scroll-container")]}
                    {:class class})
     [:div.d-flex.flex-column.px-0.mx-0.flex-grow-1
      {:class [(when container
                 "container-lg")]}
      (into [:div.flex-column.d-flex.flex-grow-1
             {:class (if padded? "p-4" "")}]
            children)]]))

(defn- header-base
  "Heading size: :h1 or :h2.
  Title-menu can be given, positioned as sibling to title.
  Actions are positioned to the end of container.

  When title is string, it is wrapped to HTML hX component.
  If title is something else than string, it is considered to be component and rendered as-is.
  "
  [heading-size title title-menu actions]
  [:div.d-flex.flex-row.mb-3.align-items-center
   [:div.d-flex.flex-row.flex-grow-1.align-items-center
    (if-not (string? title)
      ;; title is some component itself
      title
      (case heading-size
        :h1 [:h1.mb-0.mr-3 title]
        :h2 [:h2.mb-0.mr-3 title]))
    title-menu]
   actions])

(defn section-header
  "Section header is H1.
  :title: title as string (or custom component)
  :title-menu: expected a menu component, positioned as sibling to title.
  :actions: positioned to the end of container.

  If title is something else than string, it is considered to be component and rendered as-is."
  {:arglists '([& children]
               [{:keys [title title-menu actions]} & children])}
  [& args]
  (let [[{:keys [title title-menu actions]} _children] (util/parse-args args) ]
    [header-base :h1 title title-menu  actions]))

(defn view-header
  "View header is H2.
  :title: title as string (or custom component)
  :title-menu: if given, expected a menu component, positioned as sibling to title.
  :actions: positioned to the end of container.

  If title is something else than string, it is considered to be component and rendered as-is."
  {:arglists '([& children]
               [{:keys [title title-menu actions]} & children])}
  [& args]
  (let [[{:keys [title title-menu actions]} _children] (util/parse-args args) ]
    [header-base :h2 title title-menu actions]))

(defn sidebar
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)]
    (into [:div.sidebar props] children)))

(defn sidebar-header-permanent
  "Sidebar which is open by default in some view, and can't be closed.
  Another sidebar could open on top of this (or replace this).

  Action could be an dropdown menu."
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[{:keys [title action]} _children] (util/parse-args args) ]
    [:div.sidebar-header
     [:h3.sidebar-header-title.fw-medium title]
     action]))

(defn sidebar-header
  "Regular sidebar which can be closed."
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[{:keys [title on-close]} _children] (util/parse-args args)]
    [:div.sidebar-header
     [:h3.sidebar-header-title title]
     [button/close-button
      {:class "p-3"
       :on-click on-close}]]))

(defn sidebar-content
  {:arglists '([& children]
               [props & children])}
  [& args]
  (let [[props children] (util/parse-args args)]
    [:div.scroll-container
     (into [:div.p-3 props] children)]))

(defn- fade [js-props]
  (r/create-element Fade js-props))

(defn- collapse [js-props]
  ;; This js-props contains the content element tree. At one point
  ;; a element props is the Reagent Clojure argv vector,
  ;; calling js->clj here would convert also those argv vectors to
  ;; js, breaking Reagent.
  (r/create-element Collapse (js/Object.assign
                               #js {:className "sidepanel-collapse"}
                               js-props)))

(defn sidepanel
  "Similar to sidebar, but floating over the content (on large enough screen).

  Should be rendered always with `show` argument used to toggle this,
  to allow animations.

  Optional Modal `container` property controls where the Modal Dialog
  is added on the DOM, so if you want to display it under specific
  element, instead of on Document top level use the property

  Multiple sidepanels should be stackable."
  {:arglists '([& children]
               [args & children])}
  [& args]
  (let [[props children] (util/parse-args args)]
    ;; Options https://github.com/react-restart/ui/blob/main/src/Modal.tsx
    [:> Modal (r/merge-props
                {:class ["sidebar sidepanel"]
                 ;; Apply z-index offset, this is needed for stacked panels,
                 ;; where the top panel isn't inside previous panel in the DOM.
                 ;; If the panel was children of the previous panel in the DOM,
                 ;; it might be possible to handle this with CSS.
                 :style (when (:z-index props)
                          {:z-index (+ 1055 (:z-index props))})
                 :transition collapse
                 :backdropTransition fade
                 :renderBackdrop (fn [js-props]
                                   (r/create-element "div"
                                                     (js/Object.assign
                                                       #js {:className "modal-backdrop"
                                                            :style (when (:z-index props)
                                                                     #js {"z-index" (str (+ 1050 (:z-index props)))})}
                                                       js-props)))}
                (dissoc props :z-index))
     (into [:div.d-flex.flex-column] children)]))
